import * as contrato from '@/api/contrato'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDel: false
}

const mutations = {
  SETCONTRATOS (state, payload) {
    state.list = payload.list
  },
  SETCONTRATOSSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  MODALADD (state, payload) {
    state.modalAdd = payload
  },
  MODALEDIT (state, payload) {
    state.modalEdit = payload
  },
  MODALCONFDEL (state, payload) {
    state.modalConfDel = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  modalAdd: function ({ commit }, payload) {
    commit('MODALADD', payload)
  },
  modalEdit: function ({ commit }, payload) {
    commit('MODALEDIT', payload)
  },
  modalConfDel: function ({ commit }, payload) {
    commit('MODALCONFDEL', payload)
  },
  async get ({ commit }, payload) {
    let data = await contrato.get(payload)
    return data
  },
  async getContratos ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await contrato.getContratos(payload)
    commit('SETCONTRATOS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getContratosFiltro ({ commit, dispatch }) {
    let data = await contrato.getContratos(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETCONTRATOS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getContratosSelect ({ commit }, payload) {
    let data = await contrato.contratosSelect()
    commit('SETCONTRATOSSELECT', data)
  },
  async add ({ commit }, payload) {
    try {
      payload.instituicao.id = payload.instituicao.value
      payload.produto.id = payload.produto.value
      return contrato.add(payload)
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    if (payload.instituicao) {
      payload.instituicao.id = payload.instituicao.value
    }
    if (payload.produto) {
      payload.produto.id = payload.produto.value
    }
    try {
      await contrato.edit(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async del ({ commit }, payload) {
    try {
      let retorno = await contrato.del(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getContratos', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/contrato.js